module.exports = __webpack_public_path__ + "static/img/contant_1.07aadbd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1st/Articles/Article_12/contant_1.jpg
// module id = 6R4P
// module chunks = 0